module.exports = __webpack_public_path__ + "img/shake_bottom_icon.b3a7ec29.png";